import ContentArea from 'components/content-area/ContentArea';
import ContentContainer from 'components/content-container/ContentContainer';
import FrontpageHeader from 'components/frontpage-header/FrontpageHeader';

import { ISatelliteFrontpage } from 'source/NFR.types';

const narrowTextProps = {
  HtmlString: { theme: 'narrow' }
};

const SatelliteFrontpage: React.FC<ISatelliteFrontpage> = ({ satelliteHeader, content }) => {
  return (
    <div className="satellite-frontpage">
      <FrontpageHeader {...satelliteHeader} />
      <ContentContainer className="satellite-frontpage--content">
        <ContentArea
          additionalComponentProps={{
            ...narrowTextProps,
            // NOTE: RichText is just a proxy for ContentArea, so themes need to be applied using additionalComponentProps
            RichText: { additionalComponentProps: narrowTextProps }
          }}
          {...content}
        />
      </ContentContainer>
    </div>
  );
};

SatelliteFrontpage.displayName = 'SatelliteFrontpage';

export default SatelliteFrontpage;
